import { TrackingEvents } from "#webapp/src/util/analytics.util";
import { Feedback } from "@clockwise/design-system/icons";
import { useTracking } from "@clockwise/web-commons/src/util/analytics.util";
import { ListItemIcon, ListItemText, MenuItem } from "@material-ui/core";
import React, { useCallback } from "react";

export const ChromeFeedback = () => {
  const track = useTracking();
  const handleClick = useCallback(() => {
    track(TrackingEvents.CHROME_MENU.CLICK_FEEDBACK);
    window.open("https://support.getclockwise.com/hc/en-us/requests/new", "_blank");
  }, [track]);

  return (
    <MenuItem onClick={handleClick} cw-id="chrome-feedback">
      <ListItemIcon>
        <Feedback className="cw-text-muted" />
      </ListItemIcon>
      <ListItemText inset primary="Contact support" />
    </MenuItem>
  );
};
